export default class KeyValuePair<TKey = string, TValue = string>{
  public constructor(public key: TKey, public value: TValue){}
}
